
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setType } from '../filter/filterSlice';
import { fetchSingleJob, fetchToUpdateJob } from './updateAPI';


const initialState = {
    updateData: {},
    loading: false,
    isError: false,
    errorMessage: '',

    updateLoading: false,
    updateIsError: false,
    updateErrorMessage: ''


};

export const updateJob = createAsyncThunk(
    'jobs/update',
    async ({ data, navigate }, { dispatch }) => {
        const result = await fetchToUpdateJob(data);
        navigate('/')
        dispatch(setType(''))
        return result;
    }
);

export const singleJob = createAsyncThunk(
    'jobs/single',
    async (id) => {
        const result = await fetchSingleJob(id);
        return result;
    }
);
const updateSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setUpdateData: (state, action) => {
            state.updateData = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(singleJob.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
                state.isError = false;

            })
            .addCase(singleJob.fulfilled, (state, action) => {
                state.loading = false;
                state.errorMessage = '';
                state.isError = false;
                state.updateData = action.payload

            })
            .addCase(singleJob.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.error.message;
                state.isError = true;
            })

            .addCase(updateJob.pending, (state, action) => {
                state.updateLoading = true;
                state.updateErrorMessage = '';
                state.updateIsError = false;
            })
            .addCase(updateJob.fulfilled, (state, action) => {
                state.updateLoading = false;
                state.updateErrorMessage = '';
                state.updateIsError = false;
            })
            .addCase(updateJob.rejected, (state, action) => {
                state.updateLoading = false;
                state.updateErrorMessage = action.error.message;
                state.updateIsError = true;
            })


    },


});

export const { setUpdateData } = updateSlice.actions;
export default updateSlice.reducer